const setupCartAddedMessageOverride = () => {
  document.documentElement.addEventListener(
    "cart-notification:show",
    event => {
      if (event.detail?.status !== "success") return;

      const wrapper = event.target?.closest?.("[data-cart-added-message]");
      const message = wrapper?.dataset.cartAddedMessage;
      if (!message) return;

      const strings = window.themeVariables?.strings;
      if (!strings) return;

      const originalFull = strings.cartItemAdded;
      const originalShort = strings.cartItemAddedShort;
      strings.cartItemAdded = message;
      strings.cartItemAddedShort = message;

      queueMicrotask(() => {
        strings.cartItemAdded = originalFull;
        strings.cartItemAddedShort = originalShort;
      });
    },
    { capture: true }
  );
};

export default setupCartAddedMessageOverride;
